/**
=========================================================
* EGEAD Fulfilment POD - v2.2.0
=========================================================

* Product Page: https://www.egeadcompany.com/product/material-dashboard-react
* Copyright 2023 Dev Egead Company (https://www.egeadcompany.com)

Coded by www.egeadcompany.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useEffect, useState } from "react";

// react-router-dom components

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import MuiLink from "@mui/material/Link";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import TelegramIcon from "@mui/icons-material/Telegram";

// EGEAD Fulfilment POD components
import bcrypt from 'bcryptjs';
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";
// Images
import bgImage from "assets/images/bg-sign-in-basic.jpeg";
import moment from 'moment';
import { NotificationManager } from "react-notifications";
import { loginGG, setTimeHash } from 'features/slices';
import { useDispatch } from 'react-redux';
import { logout } from "features/slices";
function Basic(status) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const navigate = useNavigate();
  const handleSetRememberMe = () => setRememberMe(!rememberMe);
  const dispatch = useDispatch()
  const saltRounds = 10;

  useEffect(() => {
    if (status.status == true) {
      dispatch(logout())
    }
  })

  const handleLogin = async (e) => {
    e.preventDefault();
    
    // Kiểm tra username và password cứng
    if (username === "admin" && password === "Fulfillmentteam10") {
      try {
        // Tạo hash và time tương tự như Google login
        bcrypt.genSalt(saltRounds, (err, salt) => {
          bcrypt.hash("admin", salt, async (err, hash) => {
            const time = moment().unix()
            const res = await dispatch(loginGG(`${hash}${time}`))
            if (res.payload?.status == 0) {
              dispatch(setTimeHash({ time: parseInt(time), hash: hash, email: "admin" }));
              NotificationManager.success('Đăng nhập thành công!', 'Success', 2000);
            } else {
              NotificationManager.error('Đăng nhập không thành công!', 'Error', 3000);
            }
          });
        });
      } catch (error) {
        NotificationManager.error('Đăng nhập không thành công!', 'Error', 3000);
      }
    } else {
      NotificationManager.error('Username hoặc password không đúng!', 'Error', 3000);
    }
  };

  return (
    <BasicLayout image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Sign in
          </MDTypography>
          <Grid container spacing={3} justifyContent="center" sx={{ mt: 1, mb: 2 }}>
            <Grid item xs={2}>
              <MDTypography component={MuiLink} href="https://www.facebook.com/EGEADCompany" target="_blank" variant="body1" color="white">
                <FacebookIcon color="inherit" />
              </MDTypography>
            </Grid>
            <Grid item xs={2}>
              <MDTypography component={MuiLink} href="https://t.me/+84934982607" target="_blank" variant="body1" color="white">
                <TelegramIcon color="inherit" />
              </MDTypography>
            </Grid>
          </Grid>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form" onSubmit={handleLogin}>
            <MDBox mb={2}>
              <TextField
                type="text"
                label="Username"
                variant="outlined"
                fullWidth
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                sx={{ mb: 2 }}
              />
              <TextField
                type="password"
                label="Password"
                variant="outlined"
                fullWidth
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                sx={{ mb: 2 }}
              />
            </MDBox>
            <MDBox mt={4} mb={1}>
              <Button
                type="submit"
                variant="gradient"
                color="info"
                fullWidth
                sx={{ py: 1.5 }}
              >
                Sign in
              </Button>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default Basic;
